// Activity display names from AAA_Corona_Activity_Names.xlsx
// COMPLETE mapping covering ALL facilities: Corona, Westminster, Irwindale, San Fernando, Perris
// Single source of truth for ALL activity name displays across the application

export const ACTIVITY_DISPLAY_NAMES = {
  // ==================== A1 - QUARRY ====================
  
  // Drilling Activities
  'renewable_diesel_sandvik_1': 'Renewable Diesel Powered Sandvik 1',
  'renewable_diesel_sandvik_2': 'Renewable Diesel Powered Sandvik 2',
  'drilling_dust': 'Drilling Dust',
  
  // Blasting Activities
  'rocks_blasted': 'Amount of Rocks Blasted',
  'amount_3_8_inch': 'Amount of 3/8"',
  'amount_1_2_inch': 'Amount of 1/2"',
  'amount_1_1_2_inch': 'Amount of 1-1/2"',
  'amount_3_4_inch': 'Amount of 3/4"',
  'amount_c33': 'Amount of C33',
  'subtek_eclipse': 'Subtek Eclipse (Explosive)',
  'blasting_dust': 'Blasting Dust',
  
  // Crushing and Conveying Activities
  'rocks_to_crush': 'Rocks that will be crushed',
  'electricity_primary_crusher_telsmith': 'Electricity Used in Primary Crusher (Telsmith)',
  'electricity_primary_crusher_lippman': 'Electricity Used in Primary Crusher (Lippman)',
  'electricity_secondary_crusher_telsmith': 'Electricity Used in Secondary Crusher (Telsmith)',
  'electricity_tertiary_crusher_telsmith': 'Electricity Used in Tertiary Crusher (Telsmith)',
  'electricity_quaternary_crusher_telsmith': 'Electricity Used in Quaternary Crusher (Telsmith)',
  'electricity_feeder_telsmith': 'Electricity Used in the Feeder (Telsmith)',
  'electricity_feeder_lippman': 'Electricity Used in the Feeder (Lippman)',
  'crushing_dust': 'Dust Emissions from Crushing',
  'crushing_electricity': 'Electricity for Crushing Operations',
  'conveyers_electricity': 'Electricity for Conveyer Operations',
  
  // Processing/Screening Activities
  'crushed_rock_processing': 'Crushed Rock being Processed',
  'electricity_scalping_screen_telsmith': 'Electricity used in Scalping Screening (Telsmith)',
  'electricity_scalping_screen_simplicity': 'Electricity used in Scalping Screening (Simplicity)',
  'electricity_tertiary_screen': 'Electricity used in Tertiary Screen (Telsmith)',
  'electricity_washscreen': 'Electricity used in Washscreen',
  'electricity_dewatering_screen': 'Electricity Used in Dewatering screen',
  'electricity_wash_tank': 'Electricity consumption in Wash tank',
  'electricity_fine_material_screw': 'Electricity consumption in Fine Material Screw',
  'fuel_water_trucks': 'Fuel consumption for Water trucks',
  'screening_electricity': 'Electricity for Screening Operations',
  
  // Refining and Stacking Activities
  'crushed_rock_refining': 'Crushed rock into different particle sizes',
  'water_sprinkle_stalk_pile': 'Water Use (Sprinkle water for Stock Pile)',
  'refining_dust': 'Dust Emissions from Refining',
  
  // Raw Material Inventory - Asphalt Binders
  'pg_64_16': 'PG 64-16 (Asphalt Binder)',
  'pg_64_10': 'PG 64-10 (Asphalt Binder)',
  'pg_64_28': 'PG 64-28 (Asphalt Binder)',
  'amount_pg_64_16': 'Amount of PG 64-16',
  'amount_pg_64_10': 'Amount of PG 64-10',
  'amount_pg_64_28': 'Amount of PG 64-28',
  'amount_ra_5': 'Amount of RA-5',
  'amount_cld_mix': 'Amount of Cold Mix',
  'ra_5': 'RA-5 (Recycled Asphalt Binder)',
  'cld_mix': 'Cold Mix',
  
  // Raw Material Inventory - Additives
  'evotherm': 'Evotherm (Chemical additive)',
  'morlife': 'Morlife (Modifiers)',
  'evoflex_ca6': 'Evoflex CA-6 (Modifier)',
  'amount_evotherm': 'Amount of Evotherm',
  'amount_morlife': 'Amount of MorLife',
  'amount_evoflex_ca6': 'Amount of Evoflex CA6',
  
  // Raw Material Inventory - Reinforcement & Modifiers
  'fiber': 'Fiber (Reinforcement)',
  'amount_fiber': 'Amount of Fiber',
  'rejuvenator': 'Rejuvenator',
  'amount_rejuvenator': 'Amount of Rejuvenator',
  'anti_strip': 'Anti-strip',
  'amount_anti_strip': 'Amount of Anti-Strip',
  'rubber': 'Crumb Rubber (Modifier)',
  'amount_rubber': 'Amount of Crumb Rubber',
  'pavegrip': 'Pavegrip (Additive)',
  'amount_pavegrip': 'Amount of Pavegrip',
  'eco_spa': 'Ecospa (Additive)',
  'amount_eco_spa': 'Amount of Ecospa',
  'latex': 'Latex (Modifier)',
  'amount_latex': 'Amount of Latex',
  
  // ==================== A2 - TRANSPORT ====================
  
  // Intra-Quarry Equipment
  'loader_992_fuel_rate': 'Large Wheel Loader - 992 (Fuel Rate)',
  'loader_992_hours': 'Large Wheel Loader - 992 (Operating Hours)',
  'loader_990_fuel_rate': 'Large Wheel Loader - 990 (Fuel Rate)',
  'loader_990_hours': 'Large Wheel Loader - 990 (Operating Hours)',
  'loader_aggregate_fuel_rate': 'Wheel Loader at Aggregate Loadout (Fuel Rate)',
  'loader_aggregate_hours': 'Wheel Loader at Aggregate Loadout (Hours)',
  'loader_midsize_fuel_rate': 'Mid-Size Loader (Fuel Rate)',
  'loader_midsize_hours': 'Mid-Size Loader (Hours)',
  'bulldozer_fuel_rate': 'Bulldozer (Fuel Rate)',
  'bulldozer_hours': 'Bulldozer (Operating Hours)',
  'excavator_mining_fuel_rate': 'Excavator - Mining (Fuel Rate)',
  'excavator_mining_hours': 'Excavator - Mining (Operating Hours)',
  'hydraulic_shovel_fuel_rate': 'Hydraulic Shovel (Fuel Rate)',
  'hydraulic_shovel_hours': 'Hydraulic Shovel (Operating Hours)',
  'cat_988k_fuel_rate': 'CAT 988K (Fuel Rate)',
  'cat_988k_hours': 'CAT 988K (Operating Hours)',
  'cat_988k': 'Loader 988k',
  'haul_truck_offroad_fuel_consumption': 'Haul Trucks (Off-road)',
  'loader_diesel_processing': 'Loader Diesel for Processing',
  
  // Quarry to Plant Transport
  'truck_raw_materials_round_trip_distance': 'Truck - Raw Materials (Round Trip Distance)',
  'truck_raw_materials_capacity_divisor': 'Truck - Raw Materials (Capacity)',
  'truck_raw_materials_trips_per_day': 'Truck - Raw Materials (Trips/Day)',
  'truck_binder_fuel_consumption': 'Truck - Binder Transport',
  'truck_rubber_fuel_consumption': 'Truck - Rubber Transport',
  'truck_rubber__fuel_consumption': 'Truck - Rubber Transport',
  'truck_rejuvenators_trips_per_day': 'Truck - Rejuvenator (Trips/Day)',
  'truck_rejuvenators_round_trip_distance': 'Truck - Rejuvenator (Round Trip Distance)',
  'truck_rejuvenators_capacity_divisor': 'Truck - Rejuvenator (Capacity)',
  'truck_antistrip_trips_per_day': 'Truck - Antistrip (Trips/Day)',
  'truck_antistrip_round_trip_distance': 'Truck - Antistrip (Round Trip Distance)',
  'truck_antistrip_capacity_divisor': 'Truck - Antistrip (Capacity)',
  'rail_raw_materials_trips_per_day': 'Rail - Raw Materials (Trips/Day)',
  'rail_raw_materials_round_trip_distance': 'Rail - Raw Materials (Round Trip Distance)',
  'rail_raw_materials_capacity_divisor': 'Rail - Raw Materials (Capacity)',
  'truck_rap_fuel_consumption': 'Truck - RAP Transport',
  'truck_rejuvenators': 'Truck - Rejuvenator',
  // ==================== A3 - ASPHALT MANUFACTURING ====================
  
  // Aggregate Handling
  'diesel_agg_loader': 'Diesel Consumption for Aggregate Loader',
  'diesel_rap_loader': 'Diesel Consumption for RAP Loader',
  'electricity_virgin_agg_handling': 'Electricity Consumption for Virgin Aggregate Handling and Feeding',
  'electricity_rap_handling': 'Electricity Consumption for RAP Handling',
  'electricity_crushing_screening': 'Electricity Consumption for Crushing and Screening (Lippman Line)',
  'dust_emissions': 'Dust Emissions',
  'dust_emissions_handling': 'Dust Emissions from Handling',
  'natural_gas_dryer': 'Natural Gas consumption for Dryer Use',
  'natural_gas_hot_oil': 'Natural Gas consumption for Hot Oil heater',
  'natural_gas_hot_oil_heater': 'Natural Gas consumption for Hot Oil heater',
  'natural_gas_rubber': 'Natural Gas consumption for Rubber System',
  'natural_gas_rubber_system': 'Natural Gas consumption for Rubber System',
  'rap_drying_energy': 'RAP Drying Energy Consumption',
  
  // Drum Mixing
  'production_target': 'Production Target',
  'amount_aggregates': 'Amount of Aggregates',
  'amount_rap': 'Amount of RAP',
  'amount_ras': 'Amount of RAS',
  'fuel_red_loader': 'Fuel Consumption for Red Loader',
  'fuel_blue_loader': 'Fuel Consumption for Blue Loader',
  'fuel_white_loader': 'Fuel Consumption for White Loader',
  'fuel_yellow_loader': 'Fuel Consumption for Yellow Loader',
  'fuel_red_white_blue_loader': 'Fuel Consumption for Red/White/Blue Loader',
  'electricity_drum_mixing': 'Electricity Consumption for Drum Mixing System',
  'electricity_binder_additive': 'Electricity Consumption for Asphalt Binder & Additive System',
  'electricity_fiber_rubber': 'Electricity Consumption for Fiber and Rubber Additive System',
  
  // Baghouse Operations
  'electricity_baghouse': 'Electricity Consumption for Baghouse & Dust Collection System',
  'electricity_baghouse_dust': 'Electricity for Baghouse & Dust Collection System',
  'residual_dust': 'Residual dust emissions',
  
  // Finished Asphalt Transfer
  'electricity_conveying': 'Electricity Consumption for Conveying and Elevation (Post Mix)',
  'electricity_conveying_elevation': 'Electricity for Conveying and Elevation (Post Mix)',
  'electricity_storage_silos': 'Electricity Consumption for Storage Silos and Pumps',
  'electricity_silos_pumps': 'Electricity for Storage Silos and Pumps',
  'fuel_heating_silos': 'Fuel consumption for Heating Silos',
  'fuel_forklift': 'Fuel consumption for Forklift',
  'fuel_manlift': 'Fuel Consumption for Manlift',
  'fuel_yard_truck': 'Fuel Consumption for Yard Truck',
  'fuel_deere': 'Fuel Consumption for Deere',

  // ==================== A4-A5 - TRANSPORT FROM PLANT ====================
  
  // Transport to Site
  'total_diesel_consumption': 'Total Diesel Consumption (Transport to Site)',
  'transport_to_site': 'Transport to Site',
  
  // Ancillary Materials Transport
  'quantity_tack': 'Quantity of tack',
  'quantity_additives': 'Quantity of additives',
  'quantity_aggregates': 'Quantity of aggregates',
  'quantity_of_tack': 'Quantity of tack',
  'quantity_of_additives': 'Quantity of additives',
  'quantity_of_aggregates': 'Quantity of aggregates',
  'supplier_distance_tack': 'Supplier Distance for tack',
  'supplier_distance_additives': 'Supplier Distance for additives',
  'supplier_distance_aggregates': 'Supplier Distance for aggregates',
  'payload_per_trip': 'Payload/trip',
  'fuel_efficiency': 'Fuel Efficiency',
  'fuel_use': 'Fuel use',
  'ancillary_fuel_use': 'Ancillary Fuel Use',
  'ancillary_materials_transport': 'Ancillary Materials Transport',
  
  // Equipment Mobilization
  'fuel_lowboy_tractor': 'Lowboy Tractor diesel consumption',
  
  // Surface Preparation
  'fuel_motor_graders': 'Fuel Consumption for Motor Graders',
  'fuel_soil_compactors': 'Fuel Consumption for Soil Compactors',
  'fuel_skip_loaders': 'Fuel Consumption for Skip Loaders',
  'fuel_skip_loader': 'Fuel Consumption for Skip Loader',
  'fuel_skiploader': 'Fuel Consumption for Skip Loader',
  'diesel_skip_loader': 'Diesel for Skip Loader',
  'fuel_road_widener': 'Fuel Consumption for Road Widener',
  
  // Asphalt Laydown
  'fuel_paver_6ft': "Fuel Consumption for 6' Pavers",
  'fuel_paver_8ft': "Fuel Consumption for 8' Pavers",
  'fuel_paver_10ft': "Fuel Consumption for 10' Pavers",
  
  // Compaction
  'fuel_asphalt_compactors': 'Fuel consumption for Asphalt Compactors',
  'fuel_pneumatic_rollers': 'Fuel consumption for Pneumatic Rollers',
  'fuel_trench_rollers': 'Fuel Consumption for Trench Rollers',
  
  // Material Transfer
  'fuel_shuttles': 'Fuel consumption for Shuttles',
  'fuel_loaders': 'Fuel consumption for Loaders',
  
  // Curb and Edge Formatting
  'fuel_curb_machines': 'Fuel consumption for Curb Machines',
  'fuel_manhole_division': 'Fuel Consumption for Manhole Division',
  'fuel_scrapper': 'Fuel Consumption for Scrapper',
  'fuel_sweeper': 'Fuel Consumption for Sweeper',
  'fuel_sweeper_kick': 'Fuel Consumption for Sweeper Kick',
  
  // ==================== B2-B5 - MAINTENANCE ====================
  
  // Maintenance Materials
  'thin_overlay_asphalt': 'Amount of Thin Overlay of Asphalt',
  'slurry_seal_emulsion': 'Amount of Slurry Seal - Emulsion',
  'slurry_seal_aggregate': 'Amount of Slurry Seal - Aggregate',
  'chip_seal_binder': 'Amount of Chip Seal - Binder',
  'chip_seal_aggregate': 'Amount of Chip Seal - Aggregate',
  'crack_sealant': 'Crack Sealant',
  
  // Maintenance Equipment Fuel
  'fuel_slurry_seal_transport': 'Fuel Consumption for transporting Slurry seal',
  'fuel_transport_slurry_seal': 'Fuel for transporting Slurry seal',
  
  // ==================== C1-C4 - END OF LIFE ====================
  
  // C1 - Deconstruction (Milling and Removal)
  'fuel_skip_loader_deconstruction': 'Fuel Consumption for Skip Loader',
  'fuel_cold_planner': 'Fuel Consumption for Cold Planner',
  'fuel_backhoe': 'Fuel Consumption for BackHoe',
  'fuel_excavator': 'Fuel Consumption for Excavator',
  'fuel_root_runner': 'Fuel Consumption for Root Runner',
  
  // C2 - Transport of Milled Material
  'fuel_hauling_to_plant': 'Hauling Fuel Consumption to plant',
  'fuel_loader_diesel': 'Loader Diesel',
  'fuel_stockpile_rehandling': 'StockPile rehandling loader fuel consumption',
  
  // C3 - Processing of RAP
  'amount_rap_processing': 'Amount of RAP being processed',
  'electricity_rap_handling_eol': 'Electricity Consumption for RAP Handling',
  'electricity_crushing_screening_eol': 'Electricity Consumption for Crushing and Screening (Lippman Line)',
  
  // C4 - Disposal (If RAP is not reused)
  'fraction_to_landfill': 'Fraction to Landfill',
  'landfill_haul_fuel': 'Landfill Haul Fuel',
  'landfill_handling_diesel': 'Landfill handling Diesel',
};

/**
 * Get user-friendly display name for a technical field name.
 * Falls back to formatted field name if no mapping exists.
 * 
 * @param {string} key - Technical field name (e.g., 'renewable_diesel_sandvik_1')
 * @returns {string} User-friendly display name (e.g., 'Renewable Diesel Powered Sandvik 1')
 * 
 * @example
 * getActivityDisplayName('renewable_diesel_sandvik_1')
 * // Returns: 'Renewable Diesel Powered Sandvik 1'
 * 
 * @example
 * getActivityDisplayName('unknown_field')
 * // Returns: 'Unknown Field' (fallback to Title Case)
 */
export const getActivityDisplayName = (key) => {
  // First check if we have a custom mapping
  if (ACTIVITY_DISPLAY_NAMES[key]) {
    return ACTIVITY_DISPLAY_NAMES[key];
  }
  
  // Fallback: Convert snake_case to Title Case
  return key
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Get all display names for a specific lifecycle stage.
 * Useful for generating stage-specific UI elements.
 * 
 * @param {string} stage - Stage identifier ('quarry', 'transport', 'asphalt_manufacturing', etc.)
 * @returns {Object} Dictionary of field names to display names for that stage
 * 
 * @example
 * const quarryNames = getStageDisplayNames('quarry');
 * console.log(quarryNames['renewable_diesel_sandvik_1']);
 * // Output: 'Renewable Diesel Powered Sandvik 1'
 */
export const getStageDisplayNames = (stage) => {
  const stageKeywords = {
    'quarry': ['renewable_', 'drilling_', 'rocks_', 'blasting_', 'electricity_', 
               'crushing_', 'crushed_', 'screening_', 'conveyers_', 'fuel_water', 
               'water_', 'refining_', 'amount_', 'pg_', 'evotherm', 'morlife', 
               'evoflex', 'fiber', 'rejuvenator', 'anti_strip', 'rubber', 
               'pavegrip', 'eco_spa', 'latex'],
    'transport': ['loader_', 'bulldozer_', 'excavator_', 'hydraulic_', 'cat_', 
                  'haul_truck', 'truck_', 'rail_'],
    'asphalt_manufacturing': ['diesel_', 'electricity_', 'dust_', 'natural_gas_', 
                              'production_', 'amount_', 'fuel_', 'residual_', 'rap_drying'],
    'transport_from_plant': ['total_diesel', 'transport_to_site', 'quantity_', 
                             'supplier_', 'payload_', 'fuel_', 'ancillary_', 'diesel_skip'],
    'maintenance': ['thin_overlay', 'slurry_', 'chip_', 'crack_'],
    'end_of_life': ['fuel_', 'electricity_', 'amount_rap', 'fraction_', 'landfill_']
  };
  
  const keywords = stageKeywords[stage] || [];
  const result = {};
  
  for (const [fieldName, displayName] of Object.entries(ACTIVITY_DISPLAY_NAMES)) {
    if (keywords.some(keyword => fieldName.startsWith(keyword))) {
      result[fieldName] = displayName;
    }
  }
  
  return result;
};

/**
 * Check if a field has a custom display name mapping.
 * 
 * @param {string} key - Field name to check
 * @returns {boolean} True if custom mapping exists
 */
export const hasCustomDisplayName = (key) => {
  return key in ACTIVITY_DISPLAY_NAMES;
};

/**
 * Get all available field mappings.
 * Useful for debugging or validation.
 * 
 * @returns {Object} Complete mapping object
 */
export const getAllDisplayNames = () => {
  return { ...ACTIVITY_DISPLAY_NAMES };
};

export default {
  ACTIVITY_DISPLAY_NAMES,
  getActivityDisplayName,
  getStageDisplayNames,
  hasCustomDisplayName,
  getAllDisplayNames
};